import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RealEscalationMatrix } from "../interfaces/escalation-matrix";
import { CommonResponse } from "../interfaces/home";

@Injectable({
  providedIn: "root",
})
export class RealEscalationMatrixService {
  baseUrl = environment.baseUrl + "EscalationMatrix/";

  constructor(private http: HttpClient) {}

  getAll(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl);
  }

  getByID(id: number): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + id);
  }

  getHandlers(complaintTypeID: number): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(
      this.baseUrl + "GetHandlers/" + complaintTypeID
    );
  }

  create(data: RealEscalationMatrix) {
    return this.http.post(this.baseUrl, data);
  }

  delete(id: number) {
    return this.http.delete(this.baseUrl + id);
  }

  update(id: any, data: RealEscalationMatrix) {
    return this.http.put(this.baseUrl + id, data);
  }
}
